/* Het puntenveld onder het maaiveld wordt hier getekend in plaats van in de
   opmaak: veertig cirkels in de HTML is zonde van de laadtijd, en het veld is
   decoratief. data-na is het aantal seconden na het begin van de vierde baan
   waarop een ring verschijnt, zodat het veld zich uitbreidt nadat de kabel de
   grond heeft geraakt. */
(function(){
  var doel = document.querySelector('[data-veld]');
  if(!doel) return;
  var CX = 230, GROND = 780;
  var ringen = [[46,5],[86,8],[128,11],[172,14]];
  var ns = 'http://www.w3.org/2000/svg';
  ringen.forEach(function(ring, i){
    var straal = ring[0], aantal = ring[1];
    var dekking = Math.max(0.09, 0.34 - i * 0.06);
    var punt = Math.max(1.8, 3.4 - i * 0.42);
    for(var j = 0; j < aantal; j++){
      var hoek = (14 + (152 * j / (aantal - 1))) * Math.PI / 180;
      var c = document.createElementNS(ns, 'circle');
      c.setAttribute('cx', (CX + Math.cos(hoek) * straal).toFixed(1));
      c.setAttribute('cy', (GROND + Math.sin(hoek) * straal * 0.55).toFixed(1));
      c.setAttribute('r', punt.toFixed(2));
      c.setAttribute('fill', 'currentColor');
      c.setAttribute('class', 'fade stip');
      c.setAttribute('data-na', (1.25 + i * 0.16).toFixed(2));
      c.style.setProperty('--o', dekking.toFixed(3));
      c.style.setProperty('--d', (1.60 + i * 0.10).toFixed(2) + 's');
      doel.appendChild(c);
    }
  });
})();

/* ---------------- de reis: vier banen, vier stukjes tekst ------------------
   De tekening staat in vier groepen <g data-stap> die in de opmaak precies
   naast hun eigen tekstblok staan. Zodra een tekstblok in beeld komt tekent
   die baan zichzelf, in één keer, en daarna blijft het staan: we kijken
   maar één keer per blok, dus omhoog scrollen draait niets terug.

   Het tekenen loopt via een overgang op stroke-dashoffset. Elk pad krijgt een
   duur en een vertraging naar rato van zijn lengte, zodat de pen met een
   gelijkmatige snelheid door de hele baan loopt.
--------------------------------------------------------------------------- */
(function(){
  var DUUR = 1.05;
  var svg = document.querySelector('svg.scene');
  if(!svg) return;

  var teksten = Array.prototype.slice.call(document.querySelectorAll('.rt'));
  var banen = Array.prototype.slice.call(svg.querySelectorAll('[data-stap]'));
  banen.sort(function(a, b){
    return (+a.getAttribute('data-stap')) - (+b.getAttribute('data-stap'));
  });
  if(!banen.length) return;

  var werk = banen.map(function(g){
    var paden = Array.prototype.slice.call(g.querySelectorAll('[data-draw]'));
    var lens = paden.map(function(p){ return p.getTotalLength(); });
    var totaal = lens.reduce(function(a, b){ return a + b; }, 0) || 1;
    var gedaan = 0;
    paden.forEach(function(p, i){
      p.style.strokeDasharray = lens[i];
      p.style.strokeDashoffset = lens[i];
      p.style.transitionDuration = (lens[i] / totaal * DUUR).toFixed(3) + 's';
      p.style.transitionDelay = (gedaan / totaal * DUUR).toFixed(3) + 's';
      gedaan += lens[i];
    });
    return { g: g, paden: paden, fades: Array.prototype.slice.call(g.querySelectorAll('.fade')) };
  });

  var puls = svg.querySelector('.puls');
  if(puls){
    var L = puls.getTotalLength();
    puls.style.setProperty('--len', L);
    puls.style.strokeDasharray = '22 ' + L;
  }

  function zet(i){
    var b = werk[i];
    if(!b || b.g.classList.contains('aan')) return;
    b.g.classList.add('aan');
    b.paden.forEach(function(p){ p.style.strokeDashoffset = 0; });
    b.fades.forEach(function(f){
      f.style.transitionDelay = (parseFloat(f.getAttribute('data-na')) || DUUR) + 's';
      f.classList.add('aan');
    });
    if(teksten[i]) teksten[i].classList.add('aan');
    if(i === werk.length - 1) setTimeout(function(){ svg.classList.add('klaar'); }, 2800);
  }

  /* Wie halverwege binnenkomt, via een anker of een teruggezette scrollpositie,
     moet niet tegen een half getekende plaat aankijken. Alles erboven gaat mee. */
  function toon(i){
    for(var j = 0; j <= i; j++) zet(j);
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce || !('IntersectionObserver' in window)){
    svg.classList.add('meteen');
    toon(werk.length - 1);
    return;
  }

  /* Een waarnemer kan wegvallen, en dan blijft de plaat leeg. Daarom hangt er
     naast elke waarnemer een vangnet dat zelf meet en zich daarna afhaakt. */
  function vangnet(el, doeHet){
    function kijk(){
      var r = el.getBoundingClientRect();
      if(r.top < (window.innerHeight || 0) * 0.8 && r.bottom > 0){
        doeHet();
        removeEventListener('scroll', kijk);
      }
    }
    addEventListener('scroll', kijk, {passive:true});
    setTimeout(kijk, 1200);
  }

  function letOp(el, doeHet, marge){
    var kijker = new IntersectionObserver(function(regels){
      regels.forEach(function(regel){
        if(!regel.isIntersecting) return;
        doeHet();
        kijker.unobserve(regel.target);
      });
    }, { rootMargin: '0px 0px ' + marge + ' 0px', threshold: 0.1 });
    kijker.observe(el);
    vangnet(el, doeHet);
  }

  var smal = window.matchMedia && window.matchMedia('(max-width: 900px)').matches;

  if(smal){
    /* Op een smal scherm staat de tekening boven de vier tekstblokken in plaats
       van ernaast. Dan hoort hij in één doorlopende beweging te tekenen zodra
       de plaat zelf in beeld komt, van boven naar beneden. */
    letOp(svg, function(){
      werk.forEach(function(b, i){ setTimeout(function(){ zet(i); }, i * 480); });
    }, '-10%');
  } else {
    teksten.forEach(function(t, i){
      letOp(t, function(){ toon(i); }, '-20%');
    });
  }
})();

/* ---------------- keuzehulp ------------------------------------------------
   De vragen, de teksten en de producten komen uit Liquid, zodat alles
   vertaalbaar is en de prijzen, titels en voorraad live uit Shopify komen.

   De logica volgt de maatregels van de producten zelf:
   - hoeslaken, dekbedovertrek en kussensloop moeten precies passen; die komen
     alleen langs bij een maat die we ook echt voeren;
   - een laken en een slaapmat liggen los op het bed, dus daar mag het matras
     iets groter of kleiner zijn. Een laken dat te breed is sla je onder het
     matras in, en het smalle laken en de smalle mat kunnen dwars over het bed;
   - bij een los laken hoort het advies om lakenspanners mee te nemen.
--------------------------------------------------------------------------- */
(function(){
  var kaart = document.querySelector('[data-earthle-keuzehulp]');
  if(!kaart) return;

  function lees(kies){
    var el = document.querySelector(kies);
    if(!el) return {};
    try { return JSON.parse(el.textContent); } catch(e){ return {}; }
  }

  var P = lees('[data-earthle-producten]');
  var T = lees('[data-earthle-teksten]');
  var shopUrl = kaart.getAttribute('data-shop-url') || '/collections/all';

  var vraagvak = kaart.querySelector('.hulp-vraag');
  var terug = kaart.querySelector('.hulp-terug');
  var voortgang = kaart.querySelector('.hulp-voortgang');

  /* [sleutel van het product, sleutel van het regeltje eronder] */
  function spullen(paren){
    var uit = [];
    paren.forEach(function(paar){
      var p = P[paar[0]];
      if(!p) return;
      uit.push({ nm:p.nm, mt:p.mt, pr:p.pr, op:p.op, url:p.url, tl: paar[1] ? T[paar[1]] : '' });
    });
    return uit;
  }

  var antwoord = {};
  var stapnr = 0;

  function vraagWanneer(){
    return { kop:T.v1_kop, sub:T.v1_sub, opties:[
      {t:T.v1_a, k:T.v1_a_k, w:'slapen'},
      {t:T.v1_b, k:T.v1_b_k, w:'overdag'},
      {t:T.v1_c, k:T.v1_c_k, w:'beide'}
    ], zet:function(w){ antwoord.wanneer = w; } };
  }
  function vraagMatras(){
    return { kop:T.v2_kop, sub:T.v2_sub, opties:[
      {t:T.v2_a, k:'90', w:'90'},
      {t:T.v2_b, k:'140', w:'140'},
      {t:T.v2_c, k:'160', w:'160'},
      {t:T.v2_d, k:'180+', w:'180'},
      {t:T.v2_e, k:'?', w:'anders'}
    ], zet:function(w){ antwoord.matras = w; } };
  }
  function vraagOverdag(){
    return { kop:T.v3_kop, sub:T.v3_sub, opties:[
      {t:T.v3_a, k:'', w:'bureau'},
      {t:T.v3_b, k:'', w:'voeten'},
      {t:T.v3_c, k:'', w:'yoga'}
    ], zet:function(w){ antwoord.overdag = w; } };
  }
  function vraagStopcontact(){
    return { kop:T.v4_kop, sub:T.v4_sub, opties:[
      {t:T.v4_a, k:'', w:'ja'},
      {t:T.v4_b, k:'', w:'elders'},
      {t:T.v4_c, k:'', w:'radiator'},
      {t:T.v4_d, k:'', w:'tuin'}
    ], zet:function(w){ antwoord.stroom = w; } };
  }

  function route(){
    var r = [vraagWanneer()];
    if(antwoord.wanneer === 'slapen' || antwoord.wanneer === 'beide') r.push(vraagMatras());
    if(antwoord.wanneer === 'overdag' || antwoord.wanneer === 'beide') r.push(vraagOverdag());
    if(antwoord.wanneer) r.push(vraagStopcontact());
    return r;
  }

  /* Voor in bed. Per matrasmaat: wat past precies, wat past ook, en welk
     dekbedovertrek erbij hoort. Het overtrek staat apart omdat dat aan de maat
     van het dekbed hangt en niet aan die van het matras. */
  function slaapAdvies(){
    switch(antwoord.matras){
      case '90': return {
        waarom: T.w_90,
        hoofd: spullen([['hoeslaken90','n_hl90']]),
        naast: spullen([['laken99','n_laken_past'], ['lakenspanners','n_spanners'],
                        ['slaapmat68','n_mat_helft'], ['kussensloop','n_sloop']]),
        dekbed: spullen([['dekbed140','n_dekbed140']])
      };
      case '140': return {
        waarom: T.w_140,
        hoofd: spullen([['slaapmat137','n_mat_dekt']]),
        naast: spullen([['laken180','n_laken_ruim'], ['lakenspanners','n_spanners'],
                        ['laken99','n_laken_helft'], ['kussensloop','n_sloop']]),
        dekbed: spullen([['dekbed140','n_dekbed140']])
      };
      case '160': return {
        waarom: T.w_160,
        hoofd: spullen([['hoeslaken160','n_hl160']]),
        naast: spullen([['set','n_set'], ['laken180','n_laken_ruim'],
                        ['lakenspanners','n_spanners'], ['slaapmat137','n_mat_dekt'],
                        ['kussensloop','n_sloop']]),
        dekbed: spullen([['dekbed220','n_dekbed220']])
      };
      case '180': return {
        waarom: T.w_180,
        hoofd: spullen([['laken180','n_laken_past'], ['lakenspanners','n_spanners']]),
        naast: spullen([['slaapmat137','n_mat_helft'], ['slaapmat68','n_mat_dwars'],
                        ['kussensloop','n_sloop']]),
        dekbed: spullen([['dekbed220','n_dekbed220']])
      };
      default: return {
        waarom: T.w_anders,
        hoofd: spullen([['slaapmat68','n_mat_dwars']]),
        naast: spullen([['laken99','n_laken_dwars'], ['lakenspanners','n_spanners'],
                        ['kussensloop','n_sloop']]),
        dekbed: spullen([['dekbed140','n_dekbed_maat'], ['dekbed220','n_dekbed_maat']])
      };
    }
  }

  /* Voor overdag. Bij voeten op de grond stond hier eerst de slaapmat als
     alternatief. Dat klopte op oppervlak maar niet op gebruik: een slaapmat
     leg je op je matras. De yogamat ligt al op de grond, is groter dan de
     bureaumat en gaat mee in zijn draagtas, dus die hoort hier.

     Het regeltje eronder blijft n_mat_voeten. De tekst klopt nog steeds, want
     de yogamat is inderdaad ruimer dan de bureaumat, en zo blijven de acht
     vertalingen van die regel staan. */
  function dagAdvies(){
    switch(antwoord.overdag){
      case 'bureau': return { waarom:T.w_bureau,
        hoofd: spullen([['bureaumat','n_bureau']]), naast: [] };
      case 'voeten': return { waarom:T.w_voeten,
        hoofd: spullen([['bureaumat','n_bureau_voeten']]),
        naast: spullen([['yogamat','n_mat_voeten']]) };
      default: return { waarom:T.w_yoga,
        hoofd: spullen([['yogamat','n_yoga']]), naast: [] };
    }
  }
  function stroomAdvies(){
    switch(antwoord.stroom){
      case 'elders':   return { waarom:T.w_stroom_elders,   hoofd: spullen([['verlengsnoer','']]) };
      case 'radiator': return { waarom:T.w_stroom_radiator, hoofd: spullen([['klem','']]) };
      case 'tuin':     return { waarom:T.w_stroom_tuin,     hoofd: spullen([['pin','']]) };
      default:         return { waarom:T.w_stroom_ja,       hoofd: [] };
    }
  }

  function veilig(tekst){
    return String(tekst == null ? '' : tekst)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function itemHtml(item){
    return '<a class="item" href="' + veilig(item.url) + '">'
      + '<div class="il"><div class="nm">' + veilig(item.nm) + '</div>'
      + (item.mt ? '<div class="mt">' + veilig(item.mt) + '</div>' : '')
      + (item.tl ? '<div class="tl">' + veilig(item.tl) + '</div>' : '')
      + '<div class="op ' + (item.op ? 'ja' : 'nee') + '">'
      + veilig(item.op ? T.voorraad_ja : T.voorraad_nee) + '</div></div>'
      + '<div class="pr">' + veilig(item.pr) + '</div></a>';
  }
  function groepHtml(kop, lijst){
    if(!lijst || !lijst.length) return '';
    var h = '<div class="rol">' + veilig(kop) + '</div>';
    lijst.forEach(function(item){ h += itemHtml(item); });
    return h;
  }

  function toonAdvies(){
    var h = '<div class="advies"><div class="kop">' + veilig(T.resultaat) + '</div>';

    if(antwoord.wanneer === 'slapen' || antwoord.wanneer === 'beide'){
      var bed = slaapAdvies();
      h += '<div class="rol">' + veilig(T.rol_bed) + '</div>';
      h += '<p class="waarom">' + veilig(bed.waarom) + '</p>';
      bed.hoofd.forEach(function(item){ h += itemHtml(item); });
      h += groepHtml(T.rol_ook, bed.naast);
      h += groepHtml(T.rol_dekbed, bed.dekbed);
    }
    if(antwoord.wanneer === 'overdag' || antwoord.wanneer === 'beide'){
      var dag = dagAdvies();
      h += '<div class="rol">' + veilig(T.rol_dag) + '</div>';
      h += '<p class="waarom">' + veilig(dag.waarom) + '</p>';
      dag.hoofd.forEach(function(item){ h += itemHtml(item); });
      h += groepHtml(T.rol_ook, dag.naast);
    }

    var stroom = stroomAdvies();
    h += '<div class="rol">' + veilig(T.rol_aansluiting) + '</div>';
    h += '<p class="waarom">' + veilig(stroom.waarom) + '</p>';
    stroom.hoofd.forEach(function(item){ h += itemHtml(item); });

    h += '<div class="acts"><a class="btn btn-1" href="' + veilig(shopUrl) + '">' + veilig(T.bekijk) + '</a>'
      + '<button class="btn btn-2 opnieuw" type="button">' + veilig(T.opnieuw) + '</button></div></div>';

    vraagvak.innerHTML = h;
    var lengte = Math.max(route().length, 3);
    balken(lengte, lengte);
    terug.hidden = false;
    vraagvak.querySelector('.opnieuw').addEventListener('click', function(){
      antwoord = {}; stapnr = 0; render();
    });
  }

  /* De voortgangsbalk krijgt evenveel vakjes als er vragen in de route zitten;
     die route wordt langer of korter door het eerste antwoord. Minimaal drie,
     zodat de balk niet van één vakje naar vier springt. */
  function balken(aantal, gedaan){
    if(!voortgang) return;
    var h = '';
    for(var i = 0; i < aantal; i++) h += '<span' + (i < gedaan ? ' class="aan"' : '') + '></span>';
    voortgang.innerHTML = h;
  }

  function render(){
    var r = route();
    balken(Math.max(r.length, 3), stapnr);
    terug.hidden = stapnr === 0;
    if(stapnr >= r.length){ toonAdvies(); return; }
    var v = r[stapnr];
    var h = '<h3>' + veilig(v.kop) + '</h3><p class="sub">' + veilig(v.sub) + '</p><div class="opties">';
    v.opties.forEach(function(o, i){
      h += '<button class="optie" type="button" data-i="' + i + '"><span>' + veilig(o.t) + '</span>'
        + (o.k ? '<span class="k">' + veilig(o.k) + '</span>' : '') + '</button>';
    });
    h += '</div>';
    vraagvak.innerHTML = h;
    Array.prototype.slice.call(vraagvak.querySelectorAll('.optie')).forEach(function(knop){
      knop.addEventListener('click', function(){
        v.zet(v.opties[+knop.getAttribute('data-i')].w);
        stapnr++;
        render();
      });
    });
  }

  terug.addEventListener('click', function(){
    if(stapnr > 0) stapnr--;
    render();
  });
  render();
})();

/* ---------------- taalkiezer: open/dicht, één schakelaar voor alles --------
   Bovenin en onderin klapte de talenlijst open bij :hover, en die ging vanzelf
   weer dicht zodra de muis wegging. Op aanraakschermen bestaat die muis niet,
   en veel mobiele browsers "onthouden" welk element je als laatste hebt
   aangeraakt als :hover, ook al staat er @media (hover:hover) omheen; dat
   verschilt per toestel en app (in-app browsers zoals Instagram/Facebook
   rapporteren hover-mogelijkheden vaak niet betrouwbaar).

   23 september 2026: eerst stond hier een mix van CSS-:hover (met de media
   query eromheen) en deze tik-klasse .open. Dat werkte op sommige toestellen
   niet: een tweede tik op de knop haalde .open er via het scriptje wel af,
   maar als de browser het element ook nog als :hover zag, bleef het menu
   dankzij die andere regel gewoon in beeld staan. Nu is er nog maar één
   schakelaar: de klasse .open, hier gezet. Voor een scherm met een echte muis
   simuleert dit blok het oude hover-gedrag zelf via mouseenter/mouseleave (op
   basis van matchMedia, niet van CSS), zodat er nergens meer een aparte
   :hover-regel is die dwars kan gaan liggen.

   Verder: eerste tik op de knop opent, een volgende tik op diezelfde knop, op
   de andere taalkiezer (boven of onder), of ernaast sluit hem weer. knop.blur()
   na het sluiten haalt ook nog de focus van de knop af, voor het geval een
   andere regel ooit weer op :focus zou letten.
*/
(function(){
  var knoppen = document.querySelectorAll('.language-dropdown-toggle, .vt-taal-knop');
  if(!knoppen.length) return;

  var wraps = document.querySelectorAll('.language-dropdown, .vt-taal');
  var muis = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function alleDicht(behalve){
    Array.prototype.forEach.call(document.querySelectorAll('.language-dropdown.open, .vt-taal.open'), function(el){
      if(el !== behalve) el.classList.remove('open');
    });
  }

  Array.prototype.forEach.call(knoppen, function(knop){
    knop.setAttribute('type', 'button');
    knop.addEventListener('click', function(e){
      e.stopPropagation();
      var wrap = knop.closest('.language-dropdown, .vt-taal');
      if(!wrap) return;
      var wasOpen = wrap.classList.contains('open');
      alleDicht(wrap);
      wrap.classList.toggle('open', !wasOpen);
      if(wasOpen) knop.blur();
    });
  });

  if(muis){
    Array.prototype.forEach.call(wraps, function(wrap){
      wrap.addEventListener('mouseenter', function(){ wrap.classList.add('open'); });
      wrap.addEventListener('mouseleave', function(){ wrap.classList.remove('open'); });
    });
  }

  document.addEventListener('click', function(){ alleDicht(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') alleDicht(); });
})();

/* ---------------- beoordelingen: pijlen bij de horizontale rij ------------- */
(function(){
  var rails = Array.prototype.slice.call(document.querySelectorAll('[data-rev-rail]'));
  rails.forEach(function(rail){
    var vak = rail.closest('section');
    if(!vak) return;
    var knoppen = Array.prototype.slice.call(vak.querySelectorAll('[data-rev-schuif]'));

    function stap(){
      var kaart = rail.querySelector('.rev');
      return kaart ? kaart.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    }
    function bij(){
      var meer = rail.scrollWidth - rail.clientWidth - 4;
      knoppen.forEach(function(k){
        var kant = +k.getAttribute('data-rev-schuif');
        k.disabled = kant < 0 ? rail.scrollLeft <= 4 : rail.scrollLeft >= meer;
      });
      vak.classList.toggle('kan-schuiven', meer > 0);
    }
    knoppen.forEach(function(k){
      k.addEventListener('click', function(){
        rail.scrollBy({ left: stap() * (+k.getAttribute('data-rev-schuif')), behavior:'smooth' });
      });
    });
    rail.addEventListener('scroll', bij, {passive:true});
    addEventListener('resize', bij);
    bij();
  });
})();
